/**
 * Logger utility for consistent logging across the application
 */
class Logger {
  static log(message, ...args) {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[LOG] ${message}`, ...args);
    }
  }

  static error(message, ...args) {
    console.error(`[ERROR] ${message}`, ...args);
  }

  static warn(message, ...args) {
    console.warn(`[WARN] ${message}`, ...args);
  }

  static info(message, ...args) {
    console.info(`[INFO] ${message}`, ...args);
  }

  static debug(message, ...args) {
    if (process.env.NODE_ENV === 'development') {
      console.debug(`[DEBUG] ${message}`, ...args);
    }
  } 
}

export default Logger;
